import { useHotelCardStars } from "@website/accommodation-ui/hotel-card-new/hotel-card-stars/hotel-card-stars.hook";
import { HotelCardStarsPropertiesType } from "@website/accommodation-ui/hotel-card-new/hotel-card-stars/hotel-card-stars.types";
import { deepCompare } from "@website/utils/deep-compare";
import { numberConvert } from "@website/utils/number-convert";
import isNumber from "lodash-es/isNumber";
import { useRouter } from "next/router";
import { FC, memo } from "react";

const Component: FC<HotelCardStarsPropertiesType> = (properties) => {
  const router = useRouter();
  const {
    stars,
    showText = true,
    color = "default",
    size = "responsive",
    starSize = "small"
  } = properties;
  const { hotelStars } = useHotelCardStars(properties);

  return isNumber(stars) && stars > 0 ? (
    <div
      className={
        size === "xSmall"
          ? "flex items-center"
          : size === "small"
            ? "flex h-4 items-center"
            : "flex h-4 items-center lg:h-6"
      }
      itemProp="starRating"
      itemScope
      itemType="http://schema.org/Rating"
    >
      <meta content={`${stars}`} itemProp="ratingValue" />
      {hotelStars}
      {showText && (
        <div
          className={`mx-1 ${
            color === "neutral"
              ? "text-on-surface-medium-emphasis"
              : "text-on-surface-high-emphasis"
          }`}
        >
          {size !== "xSmall" && (
            <span
              className={`truncate ${
                starSize === "medium"
                  ? "text-caption lg:text-body-1"
                  : "text-caption"
              }`}
            >
              {`${numberConvert(stars, { locale: router.locale })} ستاره`}
            </span>
          )}
        </div>
      )}
    </div>
  ) : null;
};

export const HotelCardStars = memo(Component, deepCompare);
